import { Model } from "@bryntum/schedulerpro";
import { HasProjectMixin } from "./mixins/HasProjectMixin.jsx";
import { STORE_KEYS } from "../../other/constants/StoreKeys.jsx";
import { getAging } from "../../other/utils/utils.jsx";
import { INCENTIVE_TYPES, INCENTIVE_TYPES_VALUES } from "@/other/constants/IncentiveKeys.jsx";

export class SpotIncentive extends HasProjectMixin(Model) {
  static get $name() {
    return "SpotIncentive";
  }

  static get relations() {
    return {
      creatorRecord: {
        foreignKey: "creatorId",
        foreignStore: STORE_KEYS.boardUserStore
      },
      updaterRecord: {
        foreignKey: "updaterId",
        foreignStore: STORE_KEYS.boardUserStore
      }
    };
  }

  static get fields() {
    return [
      { name: "name", dataSource: "name" },
      { name: "taskId", dataSource: "task" },
      { name: "boardId", dataSource: "board", type: "integer" },
      { name: "resourceIds", dataSource: "resources" },
      { name: "startDate", dataSource: "start_date" },
      { name: "endDate", dataSource: "end_date" },
      { name: "positiveTagIds", dataSource: "positive_tags", defaultValue: [] },
      { name: "negativeTagIds", dataSource: "negative_tags", defaultValue: [] },
      { name: "multiplyByDays", dataSource: "multiply_by_days", type: "boolean", defaultValue: false },
      { name: "fileId", dataSource: "file", type: "integer" },
      { name: "isReleased", dataSource: "is_released", type: "boolean", defaultValue: false },
      { name: "creatorId", dataSource: "creator" },
      { name: "updaterId", dataSource: "updater" },
      { name: "createdAt", dataSource: "created_at", type: "date" },
      { name: "updatedAt", dataSource: "updated_at", type: "date" },
      { name: "archived", dataSource: "archived", type: "boolean" }
    ];
  }

  get aging() {
    return getAging(this.get("createdAt"));
  }

  get creatorUserName() {
    if (this.project && this.creatorId) {
      return this.project.boardUsersStore.getById(this.creatorId)?.name;
    }
    return "N/A";
  }

  get incentiveType() {
    return INCENTIVE_TYPES_VALUES[INCENTIVE_TYPES.SPOT];
  }

  get task() {
    if (this.project && this.taskId) {
      return this.project.extraTaskStore.getById(this.taskId);
    }
    return null;
  }

  get resource() {
    if (this.project && this.resourceId) {
      return this.project.resourceStore.getById(this.resourceId);
    }
    return null;
  }

  get positiveTags() {
    if (this.project && this.positiveTagIds?.length) {
      return this.positiveTagIds.map((tagId) =>
        this.project.incentiveTagsStore.getById(tagId)
      );
    }
    return [];
  }

  get negativeTags() {
    if (this.project && this.negativeTagIds?.length) {
      return this.negativeTagIds.map((tagId) =>
        this.project.incentiveTagsStore.getById(tagId)
      );
    }
    return [];
  }

  get resources() {
    if (this.project && this.project.resourceStore) {
      return this.project.resourceStore.query((record) =>
        this.resourceIds.includes(record.id)
      );
    }
    return [];
  }

  get fileRecord() {
    if (this.project && this.fileId) {
      return this.project.boardFilesStore.getById(this.fileId);
    }
    return null;
  }
}
